/** @typedef {{ nl: string, en: string }} LocalizedPaths */

/** @typedef {{ slug: string, paths: LocalizedPaths, path: string, faqIds: string[] }} LandingPageRoute */

/** @type {LandingPageRoute[]} */
export const LANDING_PAGE_ROUTES = [
  {
    slug: "zaagplan-maken",
    paths: {
      nl: "/zaagplan-maken",
      en: "/en/create-cut-plan",
    },
    path: "/zaagplan-maken",
    faqIds: ["takeToStore", "kerf", "storage", "multiProject"],
  },
  {
    slug: "zaagplan-mdf",
    paths: {
      nl: "/zaagplan-mdf",
      en: "/en/mdf-cut-plan",
    },
    path: "/zaagplan-mdf",
    faqIds: ["kerf", "rotation", "takeToStore"],
  },
  {
    slug: "zaagplan-multiplex",
    paths: {
      nl: "/zaagplan-multiplex",
      en: "/en/plywood-cut-plan",
    },
    path: "/zaagplan-multiplex",
    faqIds: ["rotation", "multiProject", "takeToStore"],
  },
  {
    slug: "zaagplan-spaanplaat",
    paths: {
      nl: "/zaagplan-spaanplaat",
      en: "/en/particleboard-cut-plan",
    },
    path: "/zaagplan-spaanplaat",
    faqIds: ["kerf", "takeToStore", "restStock"],
  },
  {
    slug: "zaagplan-meubelpaneel",
    paths: {
      nl: "/zaagplan-meubelpaneel",
      en: "/en/melamine-panel-cut-plan",
    },
    path: "/zaagplan-meubelpaneel",
    faqIds: ["rotation", "takeToStore", "kerf"],
  },
  {
    slug: "bouwmarkt-zaagplan",
    paths: {
      nl: "/bouwmarkt-zaagplan",
      en: "/en/hardware-store-cut-plan",
    },
    path: "/bouwmarkt-zaagplan",
    faqIds: ["takeToStore", "kerf", "exportStrategies"],
  },
  {
    slug: "zaagindeling",
    paths: {
      nl: "/zaagindeling",
      en: "/en/cut-layout",
    },
    path: "/zaagindeling",
    faqIds: ["accuracy", "multiProject", "doesNotFit"],
  },
];
